<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="fig"><img alt="" src="images/pg4_1.jpg"/></p>
<p class="ded-t"><b>Dedication</b></p>
<p class="ded-t1"><i>To the lovely ladies of my little fan club of stitchers, who join me once a month to socialize and stitch. They continue to encourage and inspire me.</i></p>
<p class="fig"><img alt="" src="images/pg4_2.jpg"/></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 0003_ded.vue?04796906